import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

function RevenueDashboard() {
  const [data, setData] = useState([]);
  const [months, setMonths] = useState([]);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  };

  useEffect(() => {
    fetchRevenueData();
  }, []);

  const fetchRevenueData = async () => {
    try {
      const projectsSnapshot = await getDocs(collection(db, 'projects'));
      const projects = projectsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      const allData = [];
      let monthsSet = new Set();

      for (let project of projects) {
        const expensesSnapshot = await getDocs(collection(db, 'projects', project.id, 'expenses'));
        const expenses = expensesSnapshot.docs.map(doc => ({
          ...doc.data(),
          value: Number(doc.data().value) || 0,
          status: doc.data().status || 'Em aberto'
        }));

        const pendingExpenses = expenses.filter(exp => exp.status === 'Em aberto');

        const revenueByMonth = {};

        for (let exp of pendingExpenses) {
          if (!exp.date) continue;
          const date = new Date(exp.date);
          if (isNaN(date)) continue;

          const yearMonth = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
          monthsSet.add(yearMonth);

          if (!revenueByMonth[yearMonth]) {
            revenueByMonth[yearMonth] = 0;
          }
          revenueByMonth[yearMonth] += exp.value;
        }

        allData.push({
          projectName: project.name || 'Sem Nome',
          revenueByMonth
        });
      }

      const sortedMonths = Array.from(monthsSet).sort();
      setMonths(sortedMonths);
      setData(allData);

    } catch (error) {
      console.error('Erro ao buscar dados de receita:', error);
    }
  };

  // Função para calcular totais por mês
  const calculateTotals = () => {
    const totals = {};
    months.forEach(month => {
      totals[month] = data.reduce((sum, project) => {
        return sum + (project.revenueByMonth[month] || 0);
      }, 0);
    });
    return totals;
  };

  const totals = calculateTotals();

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Resumo de Receitas a Receber</h1>

      <div className="grid grid-cols-[200px_repeat(auto-fit,minmax(100px,1fr))] font-semibold border-b py-2">
        <div>Projeto</div>
        {months.map(month => (
          <div key={month}>{month}</div>
        ))}
      </div>

      {data.length === 0 ? (
        <div className="py-4">Nenhuma receita registrada.</div>
      ) : (
        <ul className="space-y-2">
          {data.map(project => (
            <li key={project.projectName} className="grid grid-cols-[200px_repeat(auto-fit,minmax(100px,1fr))] items-center border-b py-2">
              <div>{project.projectName}</div>
              {months.map(month => (
                <div key={month}>
                  {project.revenueByMonth[month]
                    ? formatCurrency(project.revenueByMonth[month])
                    : '-'}
                </div>
              ))}
            </li>
          ))}

          {/* Linha de TOTAL */}
          <li className="grid grid-cols-[200px_repeat(auto-fit,minmax(100px,1fr))] items-center border-t-2 border-black py-2 font-bold">
            <div>Total</div>
            {months.map(month => (
              <div key={month}>
                {totals[month] ? formatCurrency(totals[month]) : '-'}
              </div>
            ))}
          </li>
        </ul>
      )}
    </div>
  );
}

export default RevenueDashboard;
